import { createContext, useContext, useEffect, useState } from 'react'
import { api } from '../api.js'

const DEFAULT_BRANDING = {
  site_name: 'Affisee',
  logo_url: '/affisee-login-logo.png',
  favicon_url: '/favicon.ico',
  logo_mode: 'auto',
}

const BrandingContext = createContext({ ...DEFAULT_BRANDING, refreshBranding: async () => {} })

function applyBrowserBranding(branding) {
  if (typeof document === 'undefined') return
  document.title = `${branding.site_name || DEFAULT_BRANDING.site_name} — Performance Suite`
  let icon = document.querySelector('link[data-dynamic-brand-icon]')
  if (!icon) {
    icon = document.createElement('link')
    icon.rel = 'icon'
    icon.dataset.dynamicBrandIcon = 'true'
    document.head.appendChild(icon)
  }
  icon.href = branding.favicon_url || DEFAULT_BRANDING.favicon_url
}

export function BrandingProvider({ children }) {
  const [branding, setBranding] = useState(DEFAULT_BRANDING)

  const refreshBranding = async () => {
    try {
      const value = await api('/api/branding', { auth: false, cache: 'no-store' })
      const next = { ...DEFAULT_BRANDING, ...(value || {}) }
      setBranding(next)
      applyBrowserBranding(next)
      return next
    } catch {
      applyBrowserBranding(DEFAULT_BRANDING)
      return DEFAULT_BRANDING
    }
  }

  useEffect(() => { refreshBranding() }, [])

  return (
    <BrandingContext.Provider value={{ ...branding, refreshBranding }}>
      {children}
    </BrandingContext.Provider>
  )
}

export const useBranding = () => useContext(BrandingContext)
